<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-03-26 
-->
<template>
  <Modal class="download-modal" title="导出" v-model="visible" footer-hide width="550px">
    <div class="modal-warpper">
      <!-- 导出方式 -->
      <div class="export-section">
        <div class="section-title">导出方式</div>
        <div class="export-options">
          <RadioGroup v-model="exportType" @on-change="getReportContent">
            <Radio :label="1">按期数导出（可多选）</Radio>
            <Radio :label="2">按发布时间导出</Radio>
          </RadioGroup>
          <div class="option" v-show="exportType === 1">
            <Select v-model="chapter_ids" :max-tag-count="1" multiple @on-change="getReportContent">
              <Option v-for="item in chapterList" :value="item.id" :key="item.id">第{{item.num}}期 {{item.title}}</Option>
            </Select>
          </div>
          <div class="option" v-show="exportType === 2">
            <DatePicker v-model="dateRange" class="date-range" type="daterange" placeholder="选择日期范围" format="yyyy-MM-dd" @on-change="getReportContent"></DatePicker>
          </div>
        </div>
      </div>
      <!-- 按栏目 -->
      <div class="export-section" v-if="categories.length">
        <div class="section-title">按栏目</div>
        <div class="category-options">
          <CheckboxGroup v-model="selectedCategories">
            <Checkbox :label="item.id" v-for="item in categories" :key="item.id" :disabled="selectedCategories.length == 1 && selectedCategories[0] == item.id">{{item.name}}</Checkbox>
          </CheckboxGroup>
        </div>
      </div>

      <!-- 导出按钮 -->
      <div class="export-button">
        <Button type="primary" @click="handleExport">导出EXCEL表格</Button>
      </div>
    </div>
  </Modal>
</template>
<script>
import { getReportContent } from '@/service'
import moment from 'moment'
import axios from 'axios'
export default {
  props: {
    chapterList: {
      default: () => [],
    },
    detailTitle: {
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      dateRange: [],
      categories: [],
      exportType: 1, // 1: 按期数导出, 2: 按时间导出
      chapter_ids: [],
      selectedCategories: [],
    }
  },
  methods: {
    show(chapter_id) {
      this.dateRange = []
      this.categories = []
      this.exportType = 1
      this.chapter_ids = [chapter_id]
      this.selectedCategories = []
      this.getReportContent()
      this.visible = true
    },
    handleExport() {
      // 处理导出逻辑
      if (this.exportType === 1 && !this.chapter_ids.length) {
        this.$Message.error('请选择期刊')
        return
      }
      if (this.exportType === 2 && (!this.dateRange.length || !this.dateRange[0])) {
        this.$Message.error('请选择日期')
        return
      }
      const params = {
        chapter_ids: this.exportType == 1 ? this.chapter_ids : [],
        start_time: this.exportType == 2 ? moment(this.dateRange[0]).format('YYYY-MM-DD') : '',
        end_time: this.exportType == 2 ? moment(this.dateRange[1]).format('YYYY-MM-DD') : '',
        uid: this.$route.query.uid,
        module_ids: this.selectedCategories,
        sort_type: '1',
      }

      axios
        .post(
          this.$store.state.req_url + '/dg/downloadCustomReportContentList',
          JSON.stringify(params),
          {
            headers: {
              'content-Type': 'application/json; charset=UTF-8',
            },
            responseType: 'blob',
          }
        )
        .then((response) => {
          this.exportParams(response)
        })
        .catch((error) => {
          console.error(error)
          this.$Message.error('请求错误!')
        })
    },
    exportParams(url) {
      const aLink = document.createElement('a')
      const blob = new Blob([url.data], {
        type: 'application/vnd.ms-excel',
      })
      // 创建一个当前文件的内存URL
      const _href = URL.createObjectURL(blob)
      aLink.style.display = 'none'
      aLink.href = _href
      document.body.appendChild(aLink)
      aLink.setAttribute('download', this.detailTitle + '_数据导出_' + moment().format('YYYYMMDDHHmmss') +'.xlsx')
      aLink.click()
      document.body.removeChild(aLink)
      // 手动释放创建的URL对象所占内存
      URL.revokeObjectURL(_href)

      this.$nextTick(() => {
        this.$Message.success('导出成功!')
        this.visible = false
      })
    },
    async getReportContent() {
      // console.log(this.dateRange)
      if (this.exportType === 1 && !this.chapter_ids.length) {
        this.categories = []
        return
      }
      if (this.exportType === 2 && (!this.dateRange.length || !this.dateRange[0])) {
        this.categories = []
        return
      }
      const params = {
        start_time: this.exportType == 2 ? moment(this.dateRange[0]).format('YYYY-MM-DD') : '',
        end_time: this.exportType == 2 ? moment(this.dateRange[1]).format('YYYY-MM-DD') : '',
        chapter_ids: this.exportType == 1 ? this.chapter_ids : [],
      }
      let res = await getReportContent(params, (error) => this.$Message.error('请求错误！'))
      if (res.status == 'success') {
        this.categories = res.res
        this.selectedCategories = this.categories.map((item) => item.id)
      } else {
        this.$Message.error('请求错误！')
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
.download-modal
  >>> .ivu-modal-header
    padding 14px 26px
    .ivu-modal-header-inner
      color #333333
.modal-warpper
  padding 10px
  .export-section
    margin-bottom 24px
    .section-title
      font-size 16px
      font-weight 500
      color #333
      position relative
      padding-left 12px
      margin-bottom 12px
      &:before
        content ''
        position absolute
        left 0
        top 50%
        transform translateY(-50%)
        width 4px
        height 16px
        background #FA5A00
  .option
    margin-top 15px
    .date-range
      width 260px
      >>> .ivu-icon-ios-close-circle
        cursor pointer
  >>> .export-options
    .ivu-radio-wrapper
      margin-right 20px
      line-height 22px
      color #333
      .ivu-radio-inner
        width 16px
        height 16px
        border-color #aaa
      .ivu-radio-checked
        .ivu-radio-focus
          box-shadow none
        .ivu-radio-inner
          border-color #FA5A00
          &:after
            background-color #FA5A00
            border-radius 50%
      &:last-child
        margin-right 0
  >>> .category-options
    .ivu-radio-wrapper-checked
      color #FA5A00
    .ivu-checkbox-group
      .ivu-checkbox-group-item
        display inline-flex
        line-height 22px
        margin-right 20px
        margin-bottom 10px
        color #333
        .ivu-checkbox
          margin-right 6px
          .ivu-checkbox-inner
            top 4px
            width 14px
            height 14px
        .ivu-checkbox+span, .ivu-checkbox-wrapper+span
          flex 1
        .ivu-checkbox-checked
          .ivu-checkbox-inner
            border-color #FA5A00
            background-color #FA5A00
          .ivu-checkbox-inner:after
            top 1px
            left 4px
          &.ivu-checkbox-disabled
            .ivu-checkbox-inner:after
              border-color #fff
        .ivu-checkbox-focus
          box-shadow none
  .export-button
    text-align center
    margin-top 20px
    .ivu-btn
      width 180px
      height 44px
      background #00B578
      border-color #00B578
      font-size 14px
      box-shadow none
      border-radius 6px
      &:hover
        background #00A65E
        border-color #00A65E
</style>